import { render } from "./MbTermsUrl.vue?vue&type=template&id=899cfe72&scoped=true"
import script from "./MbTermsUrl.vue?vue&type=script&lang=js"
export * from "./MbTermsUrl.vue?vue&type=script&lang=js"

import "./MbTermsUrl.vue?vue&type=style&index=0&id=899cfe72&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-899cfe72"

export default script